<template>
    <LoginContainer :logo="logo" :buttons="button" :goToRoutes="goToRoute" :errorMessage="errorMessage"
        @submit="SignIn">
        <template #form>
            <InputContent name="email" :label="$t('email')" placeholder="" v-model="email" type="email" />
            <InputContent name="password" :label="$t('password')" placeholder="" v-model="password" type="password" />
        </template>
    </LoginContainer>
</template>

<script>
import LoginContainer from '@/components/login/Login.vue';
import InputContent from '@/components/inputs/Content.vue';

import showPassLogo from "../../assets/logos/view.png";
import hidePassLogo from "../../assets/logos/hide.png";
import devLogo from "../../assets/logos/dev-logo.png"

export default {
    name: 'LoginView',
    components: {
        InputContent,
        LoginContainer,
    },

    data() {
        return {
            email: '',
            password: '',
            hidePassLogo,
            showPassLogo,
            goToRoute: [
                {
                    route: { name: 'LoginForgotPass' },
                    text: this.$t('questions.forgotPassword'),
                },
            ],
            button: [
                { text: this.$t('login'), type: 'submit' },
            ],
        }
    },

    methods: {
        async SignIn() {
            this.$store.dispatch('users/login', {
                email: this.email,
                password: this.password,
            })
        },
    },

    computed: {
        logo() {
            if (this.$store.state.instance.logo == null) {
                return devLogo
            }
            return this.$store.state.instance.logo
        },
        role() {
            return this.$store.state.users.role
        },
        errorCode() {
            return this.$store.state.users.errorCode
        },
        errorMessage() {
            switch (this.errorCode) {
                case 'auth/invalid-email':
                    return `Por favor, insira um ${this.$t('email')}`
                case 'auth/missing-password':
                    return `Por favor, insira uma ${this.$t('password')}`
                case 'auth/user-not-found':
                    return `Por favor, use um ${this.$t('email')} válido`
                case 'auth/wrong-password':
                    return `${this.$t('password')} incorrecta`
            }
            return ""
        },
    },
}
</script>

<style lang="scss" scoped>
.login {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
}
</style>
